import Favorite from '../../models/Favorite'

export const START_CREATE_NEW_FAVORITE = 'START_CREATE_NEW_FAVORITE'
export const NEW_FAVORITE_CREATED = 'NEW_FAVORITE_CREATED'
export const FAVORITE_REMOVED = 'FAVORITE_REMOVED'
export const START_FETCHING_FAVORITES = 'START_FETCHING_FAVORITES'
export const FINISH_FETCHING_FAVORITES = 'FINISH_FETCHING_FAVORITES'
export const SET_FAVORITES_ORDER = 'SET_FAVORITES_ORDER'
export const CLEAR_FAVORITES = 'CLEAR_FAVORITES'
export const CLEAR_FAVORITES_ORDER = ' CLEAR_FAVORITES_ORDER'

export function startCreateNewFavorite () {
  return {
    type: START_CREATE_NEW_FAVORITE
  }
}

export function newFavoriteCreated (favorite) {
  return {
    type: NEW_FAVORITE_CREATED,
    favorite
  }
}

export function favoriteRemoved (favoriteId) {
  return {
    type: FAVORITE_REMOVED,
    favoriteId
  }
}

export function clearFavorites () {
  return {
    type: CLEAR_FAVORITES
  }
}

export function createNewFavorite () {
  return dispatch => {
    dispatch(startCreateNewFavorite())
  }
}

export function startFetchingFavorites () {
  return {
    type: START_FETCHING_FAVORITES
  }
}

export function setFavoritesOrder (orderInfo) {
  return {
    type: SET_FAVORITES_ORDER,
    orderInfo
  }
}

export function finishFetchingFavorites (favorites, total) {
  return {
    type: FINISH_FETCHING_FAVORITES,
    favorites,
    total
  }
}

export function clearFavoritesOrder () {
  return {
    type: CLEAR_FAVORITES_ORDER
  }
}

export function fetchFavorites () {
  return (dispatch, getState) => {
    dispatch(startFetchingFavorites())

    const state = getState()
    const favoritesOrder = state.ui.favorites.orderInfo

    let params = {
      ...favoritesOrder,
      page: state.ui.favorites.page,
      per_page: 20
    }

    Favorite.findAll(params).then(({ data: favorites, headers: { total } }) => {
      dispatch(finishFetchingFavorites(favorites, total))
    })
  }
}
